import request from '@/utils/request'

// 获取机卡分离卡列表
export function findCardRiskManagesBindImei(params) {
  return request({
    url: `/card_risk_manages/bind_imei`,
    method: 'get',
    params
  })
}

// 导出机卡分离的卡
export function exportCardRiskManagesBindImei(data) {
  return request({
    url: `/card_risk_manages/bind_imei/export`,
    method: 'post',
    data
  })
}

// 获取区域限制卡列表
export function findCardRiskManagesBindArea(params) {
  return request({
    url: `/card_risk_manages/bind_area`,
    method: 'get',
    params
  })
}

// 导出区域限制卡列表
export function exportCardRiskManagesBindArea(data) {
  return request({
    url: `/card_risk_manages/bind_area/export`,
    method: 'post',
    data
  })
}
